import { format } from "date-fns";

export const COLUMNS = [
  {
    Header: "Tariff Code",
    accessor: "TariffCode"
  },
  {
    Header: "Description",
    accessor: "Description"
  },
  {
    Header: "Begin Date",
    accessor: "BeginDate",
    Cell: ({ cell }) => format(new Date(cell.value), "MM/dd/yyyy")
  },
  {
    Header: "End Date",
    accessor: "EndDate",
    Cell: ({ cell }) => format(new Date(cell.value), "MM/dd/yyyy")
  },
  {
    Header: "Min. Load",
    accessor: "MinLoad"
  },
  {
    Header: "Max. Load",
    accessor: "MaxLoad"
  },
  {
    Header: "Fuel Surcharge",
    accessor: "FuelSurchargeRate"
  },
  {
    Header: "Min. Charge",
    accessor: "MinCharge",
    Cell: ({ cell }) => (cell.value ? `$${cell.value}` : null)
  },
  {
    Header: "Tariff Type",
    accessor: "TariffType.CodeDescription",
    id: "TariffType"
  },
  {
    Header: "Status",
    accessor: "Active",
    id: "Active"
  }
];

export const TARIFF_RATE_COLUMNS = [
  {
    Header: "Tariff Code",
    accessor: "Tariff.TariffCode",
    id: "TariffCode"
  },
  {
    Header: "Max. Miles",
    accessor: "MaxMiles",
    id: "MaxMiles"
  },
  {
    Header: "Rate (¢)",
    accessor: "Rate",
    id: "Rate",
    Cell: ({ cell }) => (cell?.value ? cell.value : null)
  }
];
